// Trivia Night's client registry entry (see ../registry.ts and docs/games-contract.md).
// A party game: a big host screen + podium, no chairs — up to 20 players join
// from anywhere in the room (overlay or VR panel); an optional host runs it.

import { Brain } from 'lucide-react';
import type { GameClientDef } from '../types';
import { MAX_PLAYERS } from '../../../../supabase/functions/games/trivia-core.ts';
import { TriviaSet } from './TriviaSet';
import { TriviaScreen3D } from './TriviaScreen3D';
import { TriviaOverlay } from './TriviaOverlay';
import { TriviaVRPanel } from './TriviaVR';
import { TRIVIA_FOOTPRINT } from './triviaLayout';

export const TRIVIA_RULES = [
  {
    title: 'Joining',
    lines: [
      'Press Join on your screen (or the floating VR panel) — play from anywhere in the room, no seat needed.',
      'Up to 20 players. Latecomers can jump in mid-game and start from 0.',
      'Someone can Host: they pick the settings, run the show and don’t score. No host? The game runs itself and anyone who joined can start it.',
    ],
  },
  {
    title: 'Playing',
    lines: [
      'Each question shows on the big screen with four answers, A–D, and a countdown.',
      'Tap your answer on your own screen or VR panel. Your first tap locks in.',
      'Classic: a right answer scores 500–1000 points — the faster, the more.',
      'Buzzer: the first right answer scores 1000, then 800, 650, 500…; a wrong buzz costs 200 (scores never go below 0).',
      'After each question: the right answer, how many picked each one, and who was fastest. Standings every 5 questions.',
    ],
  },
  {
    title: 'Host controls',
    lines: [
      'Pause / Resume the clock, Skip a question (no points), Reveal the answer early, End the game, or remove a player.',
      'The host sees the right answer on their own panel.',
    ],
  },
  {
    title: 'Winning',
    lines: [
      'Most points after the last question wins — ties share the win. Points go on the Trivia leaderboard.',
      'Questions: Open Trivia DB (opentdb.com, CC BY-SA 4.0) plus GathrXR originals.',
    ],
  },
];

export const triviaClient: GameClientDef = {
  kind: 'trivia',
  label: 'Trivia Night',
  blurb: 'Big-screen party quiz for 2–20 — answer fast from your phone or VR panel, with an optional host.',
  icon: Brain,
  glyph: '★',
  category: 'party',
  minPlayers: 2,
  maxPlayers: MAX_PLAYERS,
  bots: false,
  host: 'optional',
  joinMidGame: true,
  ranking: 'points',
  chairs: [],
  footprint: TRIVIA_FOOTPRINT,
  nearRadius: 14,
  Furniture: TriviaSet,
  Table3D: TriviaScreen3D,
  Overlay: TriviaOverlay,
  VRPanel: TriviaVRPanel,
  rules: TRIVIA_RULES,
};
